export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  OFFERS: '/offers',
  OFFER_DETAIL: {
    PARAM: '/offers/:id',
    DEFAULT: '/offers',
  },
  PENDING: '/pending',
  PENDING_DETAIL: {
    PARAM: '/pending/:id',
    DEFAULT: '/pending',
  },
  PENDING_PODS: '/pods',
  PENDING_PODS_DETAIL: {
    PARAM: '/pods/:id',
    DEFAULT: '/pods',
  },
  IN_TRANSIT: '/in-transit',
  IN_TRANSIT_DETAIL: {
    PARAM: '/in-transit/:id',
    DEFAULT: '/in-transit',
  },
  DONE: '/done',
  DONE_DETAIL: {
    PARAM: '/done/:id',
    DEFAULT: '/done',
  },
  LOGOUT: '/logout',
  PASSWORD_RECOVERY: '/request_pwd',
  PASSWORD_RESET: '/reset_pwd/:token',
  DOWNLOAD_MOBILE_APP: '/mobile-app',
  ACCOUNT_SETTINGS: '/settings',
  DOCS: {
    PARAM: '/docs/:uuid',
    DEFAULT: '/docs',
  },
  DOCS_WELCOME: {
    PARAM: '/docs/:uuid/welcome/',
    DEFAULT: (uuid) => `/docs/${uuid}/welcome`,
  },
  DOCS_BILLING_DATA: {
    PARAM: '/docs/:uuid/billing-data/',
    DEFAULT: (uuid) => `/docs/${uuid}/billing-data`,
  },
  DOCS_DOCUMENTS: {
    PARAM: '/docs/:uuid/documents/',
    DEFAULT: (uuid) => `/docs/${uuid}/documents`,
  },
};

export const DOC_STEPS = {
  0: ROUTES.DOCS_WELCOME.DEFAULT,
  1: ROUTES.DOCS_BILLING_DATA.DEFAULT,
  2: ROUTES.DOCS_DOCUMENTS.DEFAULT,
};

export const MOBILE_ALLOWED_ROUTES = [
  ROUTES.DOCS.DEFAULT,
  ROUTES.ACCOUNT_SETTINGS,
  ROUTES.LOGOUT,
  ROUTES.LOGIN,
  ROUTES.HOME,
  ROUTES.PASSWORD_RECOVERY,
  ROUTES.PASSWORD_RESET,
];
